import type { ReactNode } from 'react'
import { cn } from '../cn.ts'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn('mx-auto flex max-w-sm flex-col items-center gap-3 px-6 py-16 text-center', className)}
    >
      {icon && (
        <span className="flex size-12 items-center justify-center rounded-tile bg-grey-2 text-meta">
          {icon}
        </span>
      )}
      <h2 className="text-[15px] text-text-1">{title}</h2>
      {description && <p className="text-[13px] text-text-2 leading-relaxed">{description}</p>}
      {action}
    </div>
  )
}
